import { jsxs, jsx } from "react/jsx-runtime";
const IconPropertyApartmentSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.368 5.053a1.5 1.5 0 0 1 1.5-1.5H9.08a1.5 1.5 0 0 1 1.5 1.5V22.5h1.263V5.053a1.5 1.5 0 0 1 1.5-1.5h5.21a1.5 1.5 0 0 1 1.5 1.5V22.5h1.62a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h1.618V5.053Zm1.5 17.447H9.08V5.053H3.87V22.5Zm14.685 0V5.053h-5.21V22.5h5.21Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.921 1.5a1.5 1.5 0 0 1 1.5-1.5H15a1.5 1.5 0 0 1 1.5 1.5v2.803a.75.75 0 0 1-1.5 0V1.5H7.421v2.803a.75.75 0 1 1-1.5 0V1.5Z"
        }
      )
    ]
  }
);
export {
  IconPropertyApartmentSvg
};
